module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"meta":{"title":"Häufig gestellte Fragen"},"title":"Häufig gestellte Fragen"},"en":{"meta":{"title":"Frequently Asked Questions"},"title":"Frequently Asked Questions"},"it":{"meta":{"title":""},"title":""},"lt":{"meta":{"title":"D.U.K"},"title":"D.U.K"},"pl":{"meta":{"title":"Najczęściej zadawane pytania"},"title":"Najczęściej zadawane pytania"}}')
  delete Component.options._Ctor
}
